const defaults = {
    status: 'ready',
}


export default (state=defaults, action) => {
	switch(action.type){
        case 'PAY_CHANNEL_MEMBER':
            return {...state, 'status': 'paying', 'params': action.payload.params, 'success': action.payload.success, 'fail': action.payload.fail}
        case 'PAY_REWARD':
            return {...state, 'status': 'paying', 'params': action.payload.params, 'success': action.payload.success, 'fail': action.payload.fail}
        case 'PAY_LIVEROOM':
            return {...state, 'status': 'paying', 'params': action.payload.params, 'success': action.payload.success, 'fail': action.payload.fail}
        case 'PAY_REDPACK':
            return {...state, 'status': 'paying', 'params': action.payload.params, 'success': action.payload.success, 'fail': action.payload.fail}
        case 'PAY_LECTURE':
            return {...state, 'status': 'paying', 'params': action.payload.params, 'success': action.payload.success, 'fail': action.payload.fail}
        case 'PAY_CHANNEL':
            return {...state, 'status': 'paying', 'params': action.payload.params, 'success': action.payload.success, 'cancel': action.payload.cancel, 'fail': action.payload.fail}
        case 'PAY_SUPERVIP':
            return {...state, 'status': 'paying', 'params': action.payload.params, 'success': action.payload.success, 'fail': action.payload.fail}
        case 'PAY_PGY_VIP':
            return {...state, 'status': 'paying', 'params': action.payload.params, 'success': action.payload.success, 'fail': action.payload.fail}
        case 'PAY_ERROR':
            return {...state, 'status': 'ready'}
        case 'PAY_REPAY':
            return {...state, 'status': 'ready'}
        case 'PAY_SUCCESS':
            return {...state, 'status': 'ready'}
		default: {
			return state
		}
	}
} 




// WEBPACK FOOTER //
// ./src/reducers/pay.js